export class CacheHelper {
  static EXPIRES_CONFIG = {
    'default': 24 * 60 * 60 * 1000,
  };
}
